import { useGblz } from './_csGbl';
import * as f from './_cmFTH';

import * as hf from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

//export { L } from './_cv_41a';
//export { saveAsync, D } from './_cv_41b';
export const itl_41z = () => ({ // 新規登録を考慮し、毎回新規生成
  _41rz: {},
  _411s: [],
}) as ht.dz;

export const crt_41z = async () => {
  const _gUserz = useGblz('user');
  const __41z = itl_41z();
  hf.udtDz(__41z._41rz, {
    ... ihd.i('_41r'),
    _41r_31r1f: _gUserz.crt._31rz._fst,
  });
  __41z._411s = [];
  return __41z;
};

export const load_41rLsAsync = async (pz: {
  cdn: ht.s,
}) => {
  let _cdn = f.vdd();
  _cdn += ` AND (${pz.cdn})`;
  const _ls = await f.loadLsAsync({
    tgt: '_41rs',
    cdn: _cdn,
  });
  return _ls;
};

export const load_41rDzAsync = async (pz: {
  _41r_fst: ht.n,
  cdn: ht.s,
  vsn?: ht.n,
}) => {
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (f.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : f.vdd();
//  let _cdn = f.vdd() + ` AND _fst=${pz._41r_fst}`;
  _cdn += ` AND _fst = ${pz._41r_fst}`;
  _cdn += ` AND (${pz.cdn})`;
  const _dz = await f.loadDzAsync({
    tgt: '_41rs',
    cdn: _cdn,
    lwrz: {
      _411s: {
        tgt: '_411s',
        cdn: f.vdd(false) + ` AND _411_41r1k={_41r_key}`,
        rlcz: {
          _41r_key: '_41rs._key',
        },
      },
    }
  });
  return {
    _41rz: { ... _dz, cldz: undefined },
    _411s: _dz.cldz?._411s ?? [],
  };
};

export const save_41rDzAsync = async (pz: {
  _41z: ht.dz,
  sPz?: ht.dz,
}) => {
  const _dz = await f.ugdDzAsync({
    tgt: '_41rs',
    dz: {
      ... pz._41z._41rz,
    },
    lwrz: {
      _411s: {
        tgt: '_411s',
        ls: pz._41z._411s,
/*
        rlcz: {
          _411_31r1f: '_41rs._41r_31r1f',
          _411_41r1k: '_41rs._key',
        }
*/
        udtz: {
          _411_31r1f: '_41rs._41r_31r1f',
          _411_41r1k: '_41rs._key',
        }
      },
    }
  });
  if (pz.sPz) pz.sPz.set({
    _fst: _dz._fst,
    _key: _dz._key,
  })
  return {
    _41rz: { ... _dz, cldz: undefined },
  };
};
